import { ClientSociety } from "@dune/types";
import { ControlledCheckbox } from "@dune/ui";
import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import SelectOrCreateSyndicContainer from "./SelectOrCreateSyndicContainer";
import SyndicDetailsContainer from "./SyndicDetailsContainer";

interface ActionsSyndicSelectorContainerProps {
	currentUserIsClient: boolean;
	clientIsSyndic: boolean;
}

const ActionsSyndicSelectorContainer = ({
	currentUserIsClient,
	clientIsSyndic,
}: ActionsSyndicSelectorContainerProps) => {
	const { control, getValues } = useFormContext();
	const throughSyndicValue = useWatch({
		control,
		name: "throughSyndic",
	});

	const [selectedSyndic, setSelectedSyndic] = useState<
		ClientSociety | undefined | null
	>(() => {
		const initialSyndic = getValues("syndicSociety");
		return initialSyndic?.siren ? initialSyndic : undefined;
	});
	return (
		<div className="flex flex-col gap-4">
			<ControlledCheckbox
				control={control}
				name={"throughSyndic"}
				id={"throughSyndic"}
				label={
					"La demande d'une assurance Dommage Ouvrage est formulée par la copropriété au travers d'un syndic"
				}
				className="border-gray-300 disabled:bg-gray-100"
			/>
			{throughSyndicValue &&
				!currentUserIsClient &&
				!clientIsSyndic &&
				(selectedSyndic !== undefined ? (
					<SyndicDetailsContainer
						syndic={selectedSyndic}
						setSelectedSyndic={setSelectedSyndic}
					/>
				) : (
					<SelectOrCreateSyndicContainer
						setSelectedSyndic={setSelectedSyndic}
					/>
				))}
		</div>
	);
};

export default ActionsSyndicSelectorContainer;
